import { supabase } from './supabase'
export { versionBelow } from './version'

export type AppConfig={max_game_accounts:number;maintenance_mode:boolean;minimum_web_version:string}
export async function getAppConfig(){const {data,error}=await supabase.rpc('app_config_get');if(error)throw error;return (data?.[0]??null) as AppConfig|null}
